export default __webpack_public_path__ + "static/media/AboutUsPhotoTop.143959f5.jpg";